export class ReportImageInfo {
  ControlName: string;
  ControlType: string;
  PropertyName: string;
  DataMember: string;
  OPath: string;
  Format: string;
  WidthInMM: number;
  HeightInMM: number;
  PageWidthInMM?: number;
  PageHeightInMM?: number;
  IsBackColorTransparent?: boolean;
  BandHeightInMM?: number;
  LeftInMM?: number;
  TopInMM?: number;
  LeftMarginInMM?: number;
  RightMarginInMM?: number;
  TopMarginInMM?: number;
  BottomMarginInMM?: number;
  Tag: { dpi?: number[]; rotatable?: boolean };

  constructor(data: any) {
    Object.assign(this, data);
  }
}
